import { useSearchParams } from "react-router-dom";
const { createContext } = require("react");

const FilterContext = createContext();

const FilterProvider = ({ children }) => {
  const [searchProduct, setSearchProduct] = useSearchParams();
  const [filterCategory, setFilterCategory] = useSearchParams();

  const filter = searchProduct.get("filter") || "";

  const handleFilter = (e) => {
    setSearchProduct({ filter: e.target.value });
  };

  const category = filterCategory.get("category") || "";

  const handleCategory = (e) => {
    setFilterCategory({ category: e.target.textContent });
  };

  const todosLosProducts = () => {
    setSearchProduct("");
  };

  let data = {
    filter,
    handleFilter,
    category,
    handleCategory,
    todosLosProducts,
  };

  return (
    <FilterContext.Provider value={data}>{children}</FilterContext.Provider>
  );
};

export { FilterProvider };
export default FilterContext;
